import { render } from "./JimsView.vue?vue&type=template&id=1950f101&scoped=true"
const script = {}

import "./JimsView.vue?vue&type=style&index=0&id=1950f101&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1950f101"]])

export default __exports__